import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient } from '@angular/common/http';
import { AdhesionInsuredPeopleRequestModel } from '../../../helpers/objects/request/sales-portal/adhesion-insured-people/adhesion-insured-people-request-model';
import { AdhesionInsuredPeopleResponseModel } from '../../../helpers/objects/response/sales-portal/adhesion-insured-people/adhesion-insured-people-response-model';
import { map } from 'rxjs';
import { AdhesionInsuredPeopleModel } from '../../../helpers/objects/dto/sales-portal/adhesion-insured-people/adhesion-insured-people-model';

@Injectable({
  providedIn: 'root'
})
export class PeopleAdhesionService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  private readonly selectedApi : string = '';

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;

    if(this.appConfig.platform === 'fhps'){
      this.selectedApi = this.appConfig.api + 'external/'
    } else {
      this.selectedApi = this.appConfig.api
    }
  }

  get(id: number) {
    return this.http
      .get<any>(
        this.selectedApi+
          'subscription/' +
          this.appConfig.apiPartnershipId +
          '/proposals/' +
          id +
          '/insured-people'
      )
      .pipe(map((result) => result.body as AdhesionInsuredPeopleResponseModel));
  }

  insert(id: number, body: any[]) {
    let url: string =
      this.selectedApi+
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      id +
      '/insured-people';

    let bodyCall: any = {
      insuredPeople: body
    };
    //bodyCall.insuredPeople = body;

    return this.http.post<any>(url, bodyCall).pipe(map((response) => response.body as AdhesionInsuredPeopleResponseModel));
  }

  update(id: number, body: any[]) {
    let url: string =
      this.selectedApi+
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      id +
      '/insured-people';

    let bodyCall: any = {
      insuredPeople: body
    };

    return this.http.put<any>(url, bodyCall).pipe(map((response) => response.body as AdhesionInsuredPeopleResponseModel));
  }

  setUnderwriting(id: number, body: AdhesionInsuredPeopleModel[]) {
    let url: string =
      this.selectedApi+
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      id +
      '/insured-people/underwriting';

    let bodyCall: AdhesionInsuredPeopleRequestModel = new AdhesionInsuredPeopleRequestModel();
    bodyCall.insuredPeople = body;

    return this.http.post<any>(url, bodyCall).pipe(map((response) => response.body as AdhesionInsuredPeopleModel[]));
  }

  deletePerson(proposalId: number, personId: string) {
    return this.http.delete<any>(
      this.appConfig.api + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + proposalId + '/insured-people/' + personId
    );
  }
}
